import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import ComboChart from './ComboChart';
import KpiStat from './KpiStat';
import SummaryTable from './SummaryTable';
import { monthLabel, monthLabelLong, deltaPoints, deltaCount, deltaDir } from '../helpers';
// import { monthShort } from '../helpers';

const COV = '#F5C400';

const useStyles = makeStyles((theme) => ({
	card: { overflow: 'hidden' },
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: theme.spacing(1.5, 2),
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	titleWrap: { display: 'flex', alignItems: 'center', gap: theme.spacing(1) },
	dot: { width: 8, height: 8, borderRadius: '50%', flex: 'none', backgroundColor: COV },
	title: { fontSize: 13, fontWeight: 700, letterSpacing: 0.2 },
	// pstat: { fontSize: 12, color: theme.palette.text.secondary, fontVariantNumeric: 'tabular-nums' },
	// pstatVal: { color: theme.palette.text.primary, fontWeight: 700 },
	body: { padding: theme.spacing(2) },
	chart: { position: 'relative', height: 180, marginBottom: theme.spacing(2) },
	spacer: { height: theme.spacing(1.5) },
	subhead: {
		fontSize: 11,
		fontWeight: 700,
		textTransform: 'uppercase',
		letterSpacing: 0.5,
		color: theme.palette.text.secondary,
		marginBottom: theme.spacing(1),
	},
}));

export default function CoverageModule({ data, loading, language, prevMonthKey /* , month */ }) {
	const classes = useStyles();
	const { trend = [], current = {}, previous = {}, breakdown = [] } = data || {};
	const labels = trend.map((t) => monthLabel(t.month));
	const covDelta = deltaPoints(current.rate, previous.rate);
	const attDelta = deltaCount(current.attended, previous.attended);
	const vsPrev = `${language.vs} ${monthLabelLong(prevMonthKey)}`;

	return (
		<Paper className={classes.card} elevation={1}>
			<div className={classes.header}>
				<div className={classes.titleWrap}>
					<span className={classes.dot} />
					<Typography className={classes.title}>{language.outlet_coverage}</Typography>
				</div>
				{/* <Typography className={classes.pstat}>
					{monthShort(month)}{' '}
					<span className={classes.pstatVal}>{current.rate === null ? '—' : current.rate + '%'}</span>
					{'  ·  '}
					{monthShort(prevMonthKey)} {previous.rate === null ? '—' : previous.rate + '%'}
				</Typography> */}
			</div>
			{loading && <LinearProgress />}
			<div className={classes.body}>
				<div className={classes.chart}>
					<ComboChart
						labels={labels}
						bars={[
							{ label: language.assigned, data: trend.map((t) => t.assigned), color: 'rgba(147,51,234,0.6)' },
							{ label: language.attended_label, data: trend.map((t) => t.attended), color: 'rgba(77,138,255,0.7)' },
						]}
						line={{ label: language.coverage, data: trend.map((t) => t.rate), color: COV }}
					/>
				</div>
				<Grid container spacing={1}>
					<Grid item xs={4}>
						<KpiStat
							label={language.coverage}
							value={current.rate === null ? '—' : current.rate + '%'}
							delta={covDelta === null ? null : (covDelta > 0 ? '+' : '') + covDelta + '%'}
							deltaLabel={vsPrev}
							dir={deltaDir(covDelta)}
						/>
					</Grid>
					<Grid item xs={4}>
						<KpiStat
							label={language.attended_label}
							value={current.attended}
							delta={(attDelta > 0 ? '+' : '') + attDelta}
							deltaLabel={vsPrev}
							dir={deltaDir(attDelta)}
						/>
					</Grid>
					<Grid item xs={4}>
						<KpiStat
							label={language.assigned}
							value={current.assigned}
							delta={null}
							caption={language.from_master_list}
						/>
					</Grid>
				</Grid>
				<div className={classes.spacer} />
				<Typography className={classes.subhead}>{language.summary_by_area}</Typography>
				<SummaryTable
					rows={breakdown}
					nameLabel={language.area}
					countCols={[
						{ name: 'assigned', label: language.assigned },
						{ name: 'attended', label: language.attended_label },
					]}
					rateLabel={language.coverage}
					vsLabel={vsPrev}
					barVariant="coverage"
				/>
			</div>
		</Paper>
	);
}
